export default "<app-header></app-header>\r\n<div class=\"content-section\">    \r\n    <router-outlet></router-outlet>\r\n</div>"